import { Scale, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-secondary/50 border-t border-border mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/discover" className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
                <Scale className="w-5 h-5 text-primary-foreground" />
              </div>
              <span className="text-xl font-bold text-foreground tracking-tight">
                Fund<span className="text-primary">fair</span>
              </span>
            </Link>
            <p className="text-sm text-muted-foreground">
              Collect funds. Upload receipts. Repeat.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/discover" className="text-muted-foreground hover:text-foreground transition-colors">
                  Discover Campaigns
                </Link>
              </li>
              <li>
                <Link to="/campaigns/new" className="text-muted-foreground hover:text-foreground transition-colors">
                  Start a Campaign
                </Link>
              </li>
              <li>
                <Link to="/how-to-use" className="text-muted-foreground hover:text-foreground transition-colors">
                  How to Use
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h3 className="font-semibold text-foreground">Developed By</h3>
            <div className="space-y-2">
              <p className="text-sm text-foreground font-medium">
                Catching Energy Sdn Bhd
              </p>
              <a 
                href="mailto:catchingenergysdnbhd@gmail.com" 
                className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                <Mail className="w-4 h-4" />
                catchingenergysdnbhd@gmail.com
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-border">
          <p className="text-center text-sm text-muted-foreground">
            © 2026 Catching Energy Sdn Bhd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
